import { useState, useEffect, SyntheticEvent } from 'react';
import { SearchIcon } from '@icons/Search';
import { CloseIcon } from '@icons/Close';
import { Logo } from './Logo';
import { Grid } from '../../../Grid';
import { Text as Paragraph } from '../../../Typography';
import { SideDrawer } from '../../../SideDrawer';
import { SearchOverlay } from '../../../SearchOverlay';
import type { IHeaderType } from './types';
import { NextLink } from 'components/NextLink';

import {
  HeaderGrid,
  HeaderWrapper,
  HeaderContainer,
  HeaderLogoContainer,
  LogoContainer,
  MainNav,
  LinkContainer,
  SearchBox,
  DrawerOverlay,
  SearchButton,
  SearchAnimation,
  LanguageButton,
} from './styles';
import { useRouter } from 'next/router';
import { WindowScrollService } from 'service/windowScroll/windowsScrollService';
import CustomSearch from '@/components/Instantsearch';
import { queryDebounce } from '@/components/Instantsearch/helpers/queryDebounce';
import clsx from 'clsx';
import { AVAILABLE_THEMES } from '@/styles/constants';

let secondaryNav: boolean;
const navLink = 'cursor-pointer relative main-header-link';
const HeaderMainStyle = 'sticky top-0 z-50 bg-white h-header print:hidden';

export const DesktopNavigation = ({
  data,
  hideMenu = false,
  searchData,
  popularSearchData,
  searchFeaturedCarousel,
  id = 'header-nav',
  logo,
  searchSubmitHandler,
  trackingEvents,
  countryLanguages,
  locale,
  themeName,
}: IHeaderType) => {
  const [open, openSideNav] = useState<boolean>(false);
  const [subNavData, setNavListElement] = useState<any>('');
  const [category, setCategory] = useState<any>('');
  const [subNavAssets, setSubNavAssets] = useState<any>('');
  const [navCardAdditional, setNavCardAdditional] = useState<any>('');
  const [firstCategory, setFirstCategory] = useState<any>('');
  // Accessibility
  const [focused, setFocused] = useState<boolean>();
  const [closeNav, setcloseNav] = useState<any>();
  const [openSearch, setOpenSearch] = useState<boolean>(false);
  const { asPath } = useRouter();

  const currentLanguage = locale?.substring(0, 2);
  const selectedLanguageIndex = countryLanguages?.findIndex((countryLanguage) =>
    countryLanguage.market?.includes(currentLanguage),
  );

  const searchSubmit = (value: string) => {
    WindowScrollService.clearAllBodyElementLocks();
    searchSubmitHandler(value);
  };

  const getCategoryData = (key: string) => {
    const categories = data?.filter((item: any) => {
      let navCategory;
      if (item.key === key && item.category) {
        navCategory = item;
      }
      return navCategory;
    })[0];
    return categories?.category;
  };
  const getNavData = (key: string) => {
    const links = data?.filter((item: any) => {
      if (item.key === key && item.positon === 'Main') {
        return item.key;
      }
      return false;
    })[0];
    return links;
  };
  const getMainNavKey = (key: string) => {
    const mainKey = getNavData(key);
    if (mainKey) {
      return mainKey.key;
    }
    return false;
  };
  const getSubNavData = (key: string) => {
    const navData = getNavData(key);
    if (navData?.links) {
      return navData.links;
    }
    return '';
  };
  const getSubNavImages = (key: string) => {
    const images = data?.filter((item: any) => {
      if (item.key === key && item.positon === 'Main') {
        return item;
      }
      return false;
    })[0];
    return images;
  };
  const getData = (dataKey: string) => {
    const cardItem = data?.filter((item: any) => {
      if (item?.key === dataKey) {
        return item;
      }
      return false;
    })[0];
    return cardItem;
  };
  const openSideNavHandler = (event: any) => {
    let navData = '';
    navData = event.target.getAttribute('data-subnav');
    const headerNavigation = document.querySelector('.selected');
    if (headerNavigation?.classList.contains('selected')) {
      headerNavigation?.classList.remove('selected');
    }
    event.target.classList.add('selected');
    const subNavStaticData = getSubNavData(navData);
    const navAssets = getSubNavImages(navData);
    const categoryData = getCategoryData(navData);
    let finalAsset;
    if (navAssets) {
      finalAsset = navAssets.navigation_images;
    }
    setNavListElement(subNavStaticData);
    setSubNavAssets(finalAsset);
    setCategory(categoryData);
    setNavCardAdditional(getData(navData));
    const selectedList = document.querySelector('.selected-category');
    selectedList?.classList.remove('selected-category');
    if (subNavStaticData?.length || categoryData?.length) {
      openSideNav(true);
    } else {
      openSideNav(false);
    }
    secondaryNav = false;
    const categoryWrapper = document.querySelector('.category-navigation-wapper');
    categoryWrapper?.classList.remove('hidden');
    return secondaryNav;
  };
  const getMainLink = (key: string) => {
    const cardId = data?.filter((item: any) => {
      if (item.key === key) {
        return item;
      }
      return false;
    })[0];
    return cardId.navUrl || asPath;
  };
  // accessibility
  const onKeyDown = (e: any) => {
    const { currentTarget } = e;
    currentTarget.addEventListener(
      'keyup',
      (event: any) => {
        if (event.key === 'ArrowLeft') {
          (currentTarget as HTMLElement)?.focus();
        } else if (event.key === 'ArrowRight') {
          (currentTarget as HTMLElement)?.focus();
        } else if (event.key === 'ArrowDown') {
          openSideNavHandler(event);
          setFocused(true);
          firstCategory.focus();
        }
      },
      false,
    );
  };
  const anchorClick = (e: any) => {
    const targetLink = e.currentTarget.getAttribute('href');
    if (!targetLink) {
      e.preventDefault();
    }
  };
  const overlayStyle = !open ? 'hidden transition-all duration-1000 ease-in-out' : '';
  const openSearchContainer = () => {
    setOpenSearch(!openSearch);
    WindowScrollService.lockBodyElement();
  };
  const onCloseClick = (event: any) => {
    const currentElement = event.currentTarget;
    currentElement?.classList.add('animate-rotateReverse');
    setOpenSearch(!openSearch);
    if (openSearch) {
      WindowScrollService.clearAllBodyElementLocks();
    }
  };
  // Animation
  const mouseEnterHandler = () => {
    const searchArrow = document.querySelector('.arrow');
    searchArrow?.classList.add('arrow-second');
    searchArrow?.classList.remove('arrow-first');
  };
  const mouseLeaveHandler = () => {
    const searchArrow = document.querySelector('.arrow');
    searchArrow?.classList.remove('arrow-second');
    searchArrow?.classList.add('arrow-first');
  };

  useEffect(() => {
    if (open) {
      const categoryContainer = document.querySelectorAll('.category-navigation-list');
      let timer = 0.2;
      for (let index = 0; index < categoryContainer.length; index++) {
        timer += 0.1;
        (categoryContainer[index] as HTMLElement).style.animation = `nav-enter ${timer}s ease-in`;
        (categoryContainer[index] as HTMLElement).style.display = 'block';
      }
    }
  }, [category, open]);

  const navigationEnterHandler = () => {
    const textureContainer = document.querySelector('.asset-animation');
    textureContainer?.classList.add('texture-animation');
  };
  const navigationLeaveHandler = () => {
    const categoryContainer = document.querySelectorAll('.category-navigation-list');
    for (let index = 0; index < categoryContainer.length; index++) {
      (categoryContainer[index] as HTMLElement).style.removeProperty('animation');
    }
    const textureContainer = document.querySelector('.asset-animation');
    textureContainer?.classList.remove('texture-animation');
  };
  const closeSideNavHandler = <TEvent extends SyntheticEvent>(event?: TEvent) => {
    const slectedElement = document.querySelector('.selected');
    slectedElement?.classList.remove('selected');
    openSideNav(false);
    secondaryNav = false;
    const categoryWrapper = document.querySelector('.category-navigation-wapper');
    categoryWrapper?.classList.add('hidden');

    if (event?.target) {
      const clickedElement = (event.target as HTMLElement).parentElement!;
      clickedElement.style.pointerEvents = 'none';
      // disable hover effect on currently clicked link in nav for 1 second,
      // to avoid to immediately open side drawer again
      setTimeout(() => {
        clickedElement.style.pointerEvents = 'all';
      }, 1000);
    }

    return secondaryNav;
  };
  useEffect(() => {
    const closeMainNav = document.getElementById('close-main-header');
    const firstCategoryItem = document.querySelectorAll('.category-link')[0];
    setFirstCategory(firstCategoryItem);
    setcloseNav(closeMainNav);
  }, []);
  const onKeyDownCloseNav = () => {
    closeNav.addEventListener('keyup', (event: any) => {
      if (event.key === 'Enter') {
        closeSideNavHandler();
      }
    });
  };

  const logoUrl = countryLanguages?.length > 1 ? `/${locale}` : '/';
  return (
    <>
      <HeaderGrid className={HeaderMainStyle} data-print="make-non-sticky">
        <Grid>
          <HeaderWrapper data-test="header-wrapper" className={hideMenu ? 'justify-center' : ''}>
            {!hideMenu ? (
              <HeaderContainer data-test="header-container" className="flex-grow main-header">
                {!openSearch && (
                  <MainNav data-test="main-nav" data-print="hide">
                    {data?.map((menu: any, index: number) => (
                      <NextLink
                        className="block main-menu"
                        href={getMainLink(menu.key)}
                        onKeyUp={onKeyDown}
                        data-subnav={getMainNavKey(menu.key)}
                        onClick={(event: SyntheticEvent) => [
                          anchorClick,
                          trackingEvents?.primary && trackingEvents?.primary(menu.key),
                          closeSideNavHandler(event),
                        ]}
                        key={menu.key ?? `${id + index}-menu`}
                      >
                        <LinkContainer
                          tag="div"
                          type="lead"
                          className={navLink}
                          onMouseOver={openSideNavHandler}
                          onMouseEnter={navigationEnterHandler}
                          onMouseLeave={navigationLeaveHandler}
                          data-subnav={getMainNavKey(menu.key)}
                          key={`${id + index}menu`}
                        >
                          {menu.cmsTitle}
                        </LinkContainer>
                      </NextLink>
                    ))}
                  </MainNav>
                )}
              </HeaderContainer>
            ) : (
              ''
            )}
            <HeaderLogoContainer>
              <LogoContainer
                data-test="logo"
                data-print="invisible"
                className="my-0 mx-auto print:hidden"
              >
                <NextLink
                  href={logoUrl}
                  onClick={() => {
                    if (openSearch) {
                      setOpenSearch(!openSearch);
                      WindowScrollService.clearAllBodyElementLocks();
                    }
                  }}
                >
                  <span className="sr-only">Dr. Oetker</span>
                  <Logo src={logo?.url} />
                </NextLink>
              </LogoContainer>
            </HeaderLogoContainer>
            {!hideMenu ? (
              <HeaderContainer className="justify-end">
                <SearchBox data-test="search" data-print="hide">
                  <SearchButton
                    type="button"
                    onClick={openSearchContainer}
                    className="flex items-center cursor-pointer"
                    onMouseEnter={mouseEnterHandler}
                    onMouseLeave={mouseLeaveHandler}
                    area-label="Search"
                  >
                    {!openSearch && (
                      <>
                        <SearchAnimation className="arrow-wrapper">
                          <div className="arrow arrow-first">
                            <SearchIcon />
                          </div>
                        </SearchAnimation>
                        <Paragraph
                          tag="span"
                          type="sm"
                          className="ml-2 cursor-pointer search-label font-normal tracking-wide relative text-gray-500"
                        >
                          {searchData?.copy?.searchInputText || 'Search'}
                        </Paragraph>
                      </>
                    )}
                  </SearchButton>
                  {openSearch && (
                    <button type="button" onClick={onCloseClick} className="animate-rotate">
                      <CloseIcon />
                    </button>
                  )}
                </SearchBox>
                {countryLanguages?.length > 1 ? (
                  <div
                    className={clsx(
                      'flex ml-[25px]',
                      themeName === AVAILABLE_THEMES.suprema && 'text-gray-500',
                    )}
                  >
                    {countryLanguages?.map((language, index) => (
                      <LanguageButton
                        href={language?.url ?? ''}
                        $isActive={
                          !!(index === (selectedLanguageIndex === -1 ? 0 : selectedLanguageIndex))
                        }
                        key={language?.id}
                      >
                        <Paragraph type="lead" tag="span">
                          {language?.displayName?.substring(0, 2)?.toUpperCase()}
                        </Paragraph>
                      </LanguageButton>
                    ))}
                  </div>
                ) : null}
              </HeaderContainer>
            ) : (
              ''
            )}
          </HeaderWrapper>
          <DrawerOverlay
            onMouseOver={closeSideNavHandler}
            className={overlayStyle}
            id="close-main-header"
            tabIndex={0}
            onKeyDown={onKeyDownCloseNav}
            onFocus={closeSideNavHandler}
          />
          <SideDrawer
            data-test="side-drawer"
            open={open}
            staticLinks={subNavData}
            navCategories={category}
            secondaryAssests={subNavAssets}
            secondaryNavClose={secondaryNav}
            cardAdditonalInfo={navCardAdditional}
            keyPress={focused}
            onLinkClick={closeSideNavHandler}
            trackingEvents={{
              secondary: trackingEvents?.secondary,
              tertiary: trackingEvents?.tertiary,
            }}
          />
        </Grid>
      </HeaderGrid>

      {openSearch && searchData && (
        <SearchOverlay
          searchData={searchData}
          popularSearchData={popularSearchData}
          featuredCarousel={searchFeaturedCarousel}
          setOpenSearch={setOpenSearch}
          searchSubmitHandler={searchSubmit}
          trackingEvents={{
            clickPopularSearch: trackingEvents?.clickPopularSearch,
            clickSuggestion: trackingEvents?.clickSuggestion,
            clickSearchAllSuggestions: trackingEvents?.clickSearchAllSuggestions,
          }}
        >
          <CustomSearch queryHook={queryDebounce} />
        </SearchOverlay>
      )}
    </>
  );
};
